import axios from 'axios'
import store from '@/store'

export default {
  async getAll () {
    try {
      let userId = store.state.user.id
      let response = await axios.get(store.getters.getCheckoutApi + '/transactions/user/' + userId)
      store.state.transactions = response.data
      return response.data
    } catch (e) {
      let error = {e}
      return {error: error.e.response.data}
    }
  },

  async getTransactionById (id) {
    if (store.state.transactions.length) {
      let transactions = store.state.transactions.filter(t => t.Id === id)
      if (transactions.length){
        return transactions[0]
      } else {
        return null
      }
    }
    return null
  },

  // async reportTest () {

  //   let result = await axios.get('https://qvv5kwf9h6.execute-api.us-east-1.amazonaws.com/prod/transactions/company/MeuEconomico_07576452000165?page_size=200')
  //   //let result = await axios.get('https://qvv5kwf9h6.execute-api.us-east-1.amazonaws.com/prod/transactions/company/MeuEconomico_07576452000165?page_size=200&offset_id=33e63300-f97e-11e8-a401-1d932089e61f&offset_date=1544137604299')
  //   //console.log('result', result.data)
  //   let filtered = []
  //   result.data.forEach((t) => {
  //     if (t.Status !== 3 && t.Status !== 7 && t.Status !== 8) {
  //       filtered.push({
  //         PurchaseNumber: t.PurchaseNumber,
  //         Status: t.Status,
  //         StatusDate: t.StatusDate,
  //         DeliveryTax: t.DeliveryTax,
  //         PurchaseValue: t.PurchaseValue,
  //         Total: t.DeliveryTax + t.PurchaseValue,
  //         FullName: t.FullName,
  //         Date: this.formatDate(t.StatusDate)
  //       })
  //     }
  //   })
  //   filtered.sort((a, b) => {
  //     a.StatusDate - b.StatusDate
  //   })
  //   console.log(JSON.stringify(filtered))
  //   ///transactions/company/MeuEconomico_07576452000165?page_size=100&offset_id=84b0d8e0-75ba-11e9-b816-4d4ee19dfaba
  // },

  // formatDate (timestamp) {
  //   if (timestamp) {
  //     let dtSet = new Date(Number(timestamp))
  //     return moment(dtSet).format('DD/MM/YY')
  //   } else {
  //     return '--'
  //   }
  // },
}
